import axios, { AxiosResponse } from 'axios';

export const user = {
  getAccountDetails: (): Promise<AxiosResponse> =>
    axios.get('/Account/Accountdetails'),

  getDeliveryLocations: (): Promise<AxiosResponse> =>
    axios.get('/Map/DeliveryLocations'),

  postAccountLogOff: (): Promise<AxiosResponse> =>
    axios.post('/Account/LogOff'),

  postGuestUserLogin: (): Promise<AxiosResponse> =>
    axios.post('/Account/guestUserLogin'),

  postLoginUsingPhoneNumber: (): Promise<AxiosResponse> =>
    axios.post('/Account/LoginUsingPhoneNumber'),

  postRequestPhoneLoginCodeSms: (): Promise<AxiosResponse> =>
    axios.post('/Account/RequestPhoneLoginCodeSms'),

  putOverAlcoholAgeLimit: (): Promise<AxiosResponse> =>
    axios.put('/Account/OverAlcoholAgeLimit/true'),

  putReceivePromotions: (payload): Promise<AxiosResponse> =>
    axios.put('/Account/SmsPromotionsEnabledFlag', payload),
};
